let globalConfig = {};
const setConfig = (newConfig) => {
  globalConfig = newConfig;
};
const getConfig = () => globalConfig;
export {
  getConfig,
  setConfig
};
